// extracted by mini-css-extract-plugin
export default {"heatmap":"HeatMap_heatmap__KLtb8"};